import { Link as ReactRouterLink } from "react-router-dom";
import { Box, Flex, Heading, Image, Spacer } from "@chakra-ui/react";
import logo from "../../../assets/logo_no_name.png";
import { SocialButtons } from "../index";
import React, { ReactElement } from "react";

interface Props {
  children?: ReactElement;
}
export default function Header({ children }: Props) {
  return (
    <Box as="nav" bg="talesSecondary.500">
      <Flex
        p="10px"
        alignItems="center"
        className="navbar"
        maxW="7xl"
        m="auto"
        direction={{ base: "column", sm: "row" }}
      >
        <ReactRouterLink to={"/"}>
          <Image
            src={logo}
            mr={{ base: "15px", sm: "24px", md: "30px" }}
            w={{ base: "50px", sm: "60px", md: "70px" }}
            h={{ base: "50px", sm: "60px", md: "70px" }}
          />
          <Heading size="lg" color="talesWhite">
            Tales Montagnana
          </Heading>
        </ReactRouterLink>
        <Spacer />
        <SocialButtons />
      </Flex>
      {children}
    </Box>
  );
}
